/** Presentation only. Never use these strings in forms, calculations or API payloads. */
export const DISPLAY_DECIMALS = 1;

type DisplayNumberOptions = Omit<
  Intl.NumberFormatOptions,
  | "minimumFractionDigits"
  | "maximumFractionDigits"
  | "minimumSignificantDigits"
  | "maximumSignificantDigits"
>;

const formatters = new Map<string, Intl.NumberFormat>();

/** One decimal for money; at most one for quantities, hours and percentages. */
export function displayNumberFormatter(
  options: DisplayNumberOptions = {},
): Intl.NumberFormat {
  const key = JSON.stringify(options);
  let formatter = formatters.get(key);
  if (!formatter) {
    formatter = new Intl.NumberFormat("it-IT", {
      useGrouping: true,
      ...options,
      minimumFractionDigits:
        options.style === "currency" ? DISPLAY_DECIMALS : 0,
      maximumFractionDigits: DISPLAY_DECIMALS,
    });
    formatters.set(key, formatter);
  }
  return formatter;
}

/** For read-only values returned as decimal strings by the API. */
export function formatDisplayNumber(
  value: string | number | null | undefined,
): string {
  if (value === null || value === undefined || String(value).trim() === "")
    return "—";
  const numeric = Number(value);
  return Number.isFinite(numeric)
    ? displayNumberFormatter().format(numeric)
    : "—";
}
